import React, { useState } from 'react'
// @mui material components
import Card from "@mui/material/Card";
import Tooltip from "@mui/material/Tooltip";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from 'components/MDInput';
import EditSessionReq from "../../../../Classes/Models/Requests/Administration/CreateSessionReq"
import SessionsApi from '../../../../Classes/API/Administration/SessionsApi';
const index = ({ Session, setShowEdit, setIsLoaded }) => {

  let editReq = new EditSessionReq();
  const SaveEdit = async (session) => {
    console.log(session)
    var nameVal = document.getElementById("S.Name" + session.id).value;

    var descriptionVal = document.getElementById("S.Description" + session.id).value;
    var categoryVal = document.getElementById("S.Category" + session.id).value;

    var SecretNameVal = document.getElementById("S.SecretName" + session.id).value;
    var EgyptianPriceVal = document.getElementById("S.EgyptianPrice" + session.id).value;
    var ArabPriceVal = document.getElementById("S.ArabPrice" + session.id).value;
    var OtherPriceVal = document.getElementById("S.OtherPrice" + session.id).value;
    var IsHalfDurationVal = document.getElementById("S.IsHalfDuration" + session.id).checked;
    var IsAssessmentSessionVal = document.getElementById("S.IsAssessmentSession" + session.id).checked;

    editReq.Id = session.id;
    editReq.Name = nameVal;
    editReq.Category = categoryVal;

    editReq.Description = descriptionVal;
    editReq.SecretName = SecretNameVal;
    editReq.EgyptianPrice = EgyptianPriceVal;
    editReq.ArabPrice = ArabPriceVal;
    editReq.OtherPrice = OtherPriceVal;
    editReq.IsHalfDuration = IsHalfDurationVal;
    editReq.IsAssessmentSession = IsAssessmentSessionVal;


    editReq.Image = undefined;

    var editRes = await SessionsApi.EditSession(editReq)

    if (editRes.status == "Success") {
      setIsLoaded(false)
    }

  }


  return (
    <div className="mb-3 col-md-12">
      <div className="card"> 
    <Card sx={{ height: "100%", boxShadow: !false && "none" }}>
      <MDBox display="flex" justifyContent="space-between" alignItems="center" pt={2} px={2}>
        <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
          Edit Session: {Session.name}  with Id : {Session.id}
        </MDTypography>
        <MDTypography variant="body2" color="secondary">
          <Tooltip title={"Back to Details"} onClick={() => setShowEdit(false)} placement="top">
            <Icon>edit</Icon>
          </Tooltip>
        </MDTypography>
      </MDBox>
      <MDBox p={2}>



        <div className="container-fluid my-3 px-3">
          <div className="row">
            <div className="col-md-4 my-2">
              <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                Name: &nbsp;
              </MDTypography>
              <MDTypography variant="button" fontWeight="regular" color="text">
                &nbsp;<MDInput id={"S.Name" + Session.id} type="text" defaultValue={Session.name}></MDInput>
              </MDTypography>
            </div>
            <div className="col-md-4 my-2">
              <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                &nbsp;Description:
              </MDTypography>
              <MDTypography variant="button" fontWeight="regular" color="text">
                &nbsp; <MDInput id={"S.Description" + Session.id} type="text" defaultValue={Session.description}></MDInput>

              </MDTypography>
            </div>

            <div className="col-md-4 my-2">
              <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                &nbsp;Category:
              </MDTypography>
              <MDTypography variant="button" fontWeight="regular" color="text">
                &nbsp; <MDInput id={"S.Category" + Session.id} type="text" defaultValue={Session.category}></MDInput>

              </MDTypography>
            </div>

            <div className="col-md-4 my-2">
              <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                &nbsp;Secret Name:
              </MDTypography>
              <MDTypography variant="button" fontWeight="regular" color="text">
                &nbsp; <MDInput id={"S.SecretName" + Session.id} type="text" defaultValue={Session.secretName}></MDInput>

              </MDTypography>
            </div>

            <div className="col-md-4 my-2">
              <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                &nbsp;Egyptian Price:
              </MDTypography>
              <MDTypography variant="button" fontWeight="regular" color="text">
                &nbsp; <MDInput id={"S.EgyptianPrice" + Session.id} type="number" defaultValue={Session.egyptianPrice}></MDInput>

              </MDTypography>
            </div>

            <div className="col-md-4 my-2">
              <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                &nbsp;Arab Price:
              </MDTypography>
              <MDTypography variant="button" fontWeight="regular" color="text">
                &nbsp; <MDInput id={"S.ArabPrice" + Session.id} type="number" defaultValue={Session.arabPrice}></MDInput>

              </MDTypography>
            </div>

            <div className="col-md-4 my-2">
              <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                &nbsp;Other Price:
              </MDTypography>
              <MDTypography variant="button" fontWeight="regular" color="text">
                &nbsp; <MDInput id={"S.OtherPrice" + Session.id} type="number" defaultValue={Session.otherPrice}></MDInput>

              </MDTypography>
            </div>

            <div className="col-md-4 my-2">
              <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                &nbsp; Half Duration:
              </MDTypography>
              <MDTypography variant="button" fontWeight="regular" color="text">
                &nbsp;
                <input id={"S.IsHalfDuration" + Session.id}
                  type="checkbox"
                  defaultChecked={Session.isHalfDuration}
                />

              </MDTypography>
            </div>

            <div className="col-md-4 my-2">
              <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                &nbsp; Assessment Session:
              </MDTypography>
              <MDTypography variant="button" fontWeight="regular" color="text">
                &nbsp;
                <input id={"S.IsAssessmentSession" + Session.id}
                  type="checkbox"
                  defaultChecked={Session.isAssessmentSession}
                />

              </MDTypography>
            </div>

            <div className="col-md-4 my-2">
              <button onClick={() => SaveEdit(Session)} className='btn btn-outline-success'>SAVE</button>
            </div>

          </div>
        </div>

      </MDBox>
    </Card>
    </div>
    </div>
  )
}

export default index